<template>
  <div class="search-component-container">
    <div class="search-component-wrapper">
      <input 
        type="text" 
        :value="searchQuery" 
        @input="handleSearch"
        :placeholder="placeholder" 
        class="search-component-input"
      />
      <i class="bi bi-search search-component-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchComponent',
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search...'
    }
  },
  methods: {
    handleSearch(event) {
      this.$emit('search', event.target.value);
    }
  }
}
</script>

<style src="@/components/styles/SearchComponent.css"></style>
